<template>
  <v-card class="pa-2 text-center" flat tile>
    <span v-html="esptecPzCaja(EspecifTecnica)"></span>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    computed: {
      ...mapState(["EspecifTecnica"]),
      esptecPzCaja() {
        return (nodo) => {
          if (nodo.length !== 0) {
            const dscr = nodo.filter((x) => x.Descripcion == "PIEZAS POR CAJA")
            if (dscr.length !== 0) {
              const val = dscr[0].Valor
              return val
            } else return ""
          } else return ""
        }
      }
    },
  };
</script>

<style></style>
